import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LocationService } from '../services/location.service';
import { SortableComponent } from '../../core/sortable/sortable.component';
import { RouteHelperService } from '../../core/services/route-helper.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'ch-location-listing',
  templateUrl: './location-listing.component.html',
  styleUrls: ['./location-listing.component.css'],
})
export class LocationListingComponent implements OnInit, OnDestroy {
  public items = [];
  public totalItems;
  public pageParams: any = {};

  public loading: boolean;
  private editMode: boolean;

  public breadcrumb: string[] = [];

  constructor(
    private locationService: LocationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private routeHelperService: RouteHelperService,
    private titleService: Title,
  ) {}

  ngOnInit() {
    this.titleService.setTitle(`Locations | CODE Hospitality CMS`);
    this.activatedRoute.queryParamMap
      .map((params: Params) => params.params)
      .subscribe(params => {
        this.pageParams = this.routeHelperService.getValidatedParams(params);

        this.setLocationBreadcrumb(this.pageParams.parentId);

        this.loadItems(this.pageParams);
      });
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  private setLocationBreadcrumb(id: string) {
    if (!id) {
      this.breadcrumb = ['Locations'];
      return;
    }

    this.locationService.getLocationParentTree(id).then((resp: any[]) => {
      let a = ['Locations', ...resp];
      let result = [];

      for (let i = 0; i < a.length; i++) {
        let item = a[i];
        if ('object' === typeof item) {
          result.push({
            name: item.name || item.nameEn,
            data: item.id,
          });
        } else {
          result.push(
            0 === i
              ? {
                  name: item,
                  data: 'top',
                }
              : item
          );
        }
      }

      this.breadcrumb = result;
    });
  }

  public breadcrumbGoTo(data) {
    if ('top' === data) {
      this.router.navigate(['/admin/locations']);
    } else {
      this.goToSubroute(data);
    }
  }

  public goToSubroute(id: string) {
    this.router.navigate(['/admin/locations'], {
      queryParams: { parentId: id },
    });

    return false;
  }

  public search(event) {
    this.queryParams({
      query: event,
    });
  }

  public onSort(data) {
    this.queryParams({
      sortBy: data.column,
      sortOrder: data.order,
    });
  }

  public onPageChanged(pageNumber) {
    this.queryParams({
      pageNumber: pageNumber,
    });
  }

  private queryParams(params) {
    const result = this.routeHelperService.queryParams(params, this.pageParams);
    this.router.navigate([], { queryParams: result });
  }

  private loadItems(data) {
    this.loading = true;
    const handle = result => {
      const jsonData = result.json();
      this.items = jsonData.items;
      this.totalItems = jsonData.totalItems;
      this.loading = false;
    };

    if (data.parentId) {
      this.locationService.getSubLocations(data.parentId, data).subscribe(handle);
    } else {
      this.locationService.getLocations(data).subscribe(handle);
    }
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/locations/location-listing/location-listing.component.ts